export class Requirement {
    requirementid: number;
    requirementfor: string; //poNumber is a name of the input field
    requirementdetails: string;      //poDate is a name of the input field 
    requirementdate: Date;
	vendorid:number;
	amount: number;
    status: number;
    createdon: Date;
    createdby: string;
    requirementpath: string;
	quotationcount: number;
    // active: number;
}